<template>
  <div class="answerItem">
    <!-- <a-empty
      v-if="answerList.length==0"
      description="暂无课程问答"
    /> -->
    <div class="notbox"  v-if="answerList.length==0">
      <img
        src="../../assets/blank/notanswer.png"
        alt=""
      >
      <p class="inp">暂无课程问答</p>
    </div>
    <div
      class="box"
      v-else
      v-for="item in answerList"
      :key="item.id"
      @click="$emit('todetail',item.id,answerId)"
    >
      <div class="left">
        <img
          class="touimg"
          v-if="item.creator&&item.creator.icon"
          :src="item.creator.icon"
          alt=""
        >
        <img
          class="touimg"
          v-else
          src="../../assets/course/icon.png"
          alt=""
        >
      </div>
      <div class="right">
        <p class="title"><span>{{item.creator.name}}</span><span>{{item.pubTime}}</span></p>
        <p class="info">{{item.title}}</p>
        <p class="log">
          <ul class="logul">
            <li
              v-for="(v,index) in item.tag"
              :key="index"
            >{{v}}</li>
          </ul>
          <ul class="vwul">
            <li>
              <span>浏览</span>
              <img
                src="../../assets/course/icon1.png"
                alt=""
              >
              <span>{{item.scannedNum}}</span>
            </li>
            <li>
              <span>回复</span>
              <img
                src="../../assets/course/icon2.png"
                alt=""
              >
              <span>{{item.replyNum}}</span>
            </li>
          </ul>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "answerItem",
  props: {
    answerList: Array,
    answerId: [String,Number],
  },
};
</script>

<style lang="stylus" scoped>
.answerItem {
  .notbox{
    margin:0 auto;
    margin-bottom:30px;
    margin-top:40px;
    text-align center;
    img {
      display:block
      margin:0 auto;
    }
  .inp {
      font-size: 18px;
      color: #666;
      margin: 0 auto;
      text-align: center;
      margin-top: 10px;
    }
  }
  .box {
    height: 150px;
    border-bottom: 1px solid #eee;
    display: flex;
    cursor: pointer;

    .left {
      width: 50px;
      padding-top: 30px;

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }

    .right {
      flex: 1;
      padding-left: 15px;

      .title {
        padding-top: 30px;
        margin-bottom: 18px;

        span:nth-child(1) {
          color: #666;
          font: size 14px;
        }

        span:nth-child(2) {
          color: #999;
          font-size: 12px;
          padding-left: 29px;
        }
      }

      .info {
        margin-bottom: 15px;
        color: #333333;
        overflow: hidden;
        width: 600px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .log {
        display: flex;
        margin-bottom: 25px;
        position: relative;

        .logul {
          display: flex;
          margin-bottom: 0px;

          li {
            min-width: 56px;
            padding-left:5px;
            padding-right:5px;
            height: 20px;
            background-color: #e3f8ff;
            border: solid 1px #bfdfff;
            margin-right: 5px;
            text-align: center;
            line-height: 19px;
            font-size: 12px;
            color: #666;
          }

          li:last-child {
            margin-right: 0px;
          }
        }

        .vwul {
          display: flex;
          height: 20px;
          margin-bottom: 0px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;

          li {
            width: 110px;
            height: 20px !important;
            text-align: center;
            display: flex;
            color: #999;
            font-size: 12px;
            align-items: center;
            justify-content: center;
            line-height: 20px;
          }

          li:nth-child(1) {
            border-right: 1px solid #b7b7b7;

            img {
              width: 18px;
              height: 14px;
              margin-left: 6px;
              margin-right: 6px;
            }
          }

          li:nth-child(2) {
            img {
              width: 15px;
              height: 13px;
              margin-left: 6px;
              margin-right: 6px;
            }
          }
        }
      }
    }
  }

  .box:hover {
    .info {
      color: #f0cd48;
    }
  }
}
</style>
